export default __webpack_public_path__ + "static/media/skills-hd.png?baeae017";